import { defineComponent } from "vue";

import { ITypeaheadOptions } from "../../../../../interfaces/i-typeahead";

import TypeaheadInput from "../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";

export default defineComponent({
    components: {
        TypeaheadInput
    },

    props: {
        fileDetail: {
            type: Object,
            default: null
        },
        getFileIcon: {
            type: Function
        },
        uploading: {
            type: Boolean,
            default: null
        },
        searchedTypes: {
            type: Array,
            default: []
        },
        fileIndex: {
            type: Number,
            default: null
        },
        isFieldRequired: {
            type: Function
        }
    },
    inject: ["v"],

    data() {
        return {
            selectedUploadType: undefined,
            v$: this.v as any
        };
    },

    emits: ["remove-file"],

    methods: {
        uploadTypeChanged(newValue: ITypeaheadOptions) {
            if (newValue) {
                this.fileDetail.type = newValue;
            }
        },

        removeFile() {
            this.$emit("remove-file");
        }
    }
});
